module.exports = __webpack_public_path__ + "static/media/zoom-reset.b2d6885c.svg";